import { render } from "./evperks.vue?vue&type=template&id=c7b661a6&scoped=true"
import script from "./evperks.vue?vue&type=script&lang=js"
export * from "./evperks.vue?vue&type=script&lang=js"

import "./evperks.vue?vue&type=style&index=0&id=c7b661a6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c7b661a6"

export default script